@if (visible) {
  <div class="row g-0 mb-1">
    <div class="col">
      @if (paging.count > 0) {
        <span>
          Viewing {{ viewing }} of <strong>{{ paging.count | number: '' }} </strong> {{ label }}
        </span>
      }
      <ng-content />
    </div>
    <div class="col">
      <form novalidate class="form-inline float-end">
        @if (paging.totalPages > 0) {
          <span>
            Page {{ paging.currentPage }} of {{ paging.totalPages }}
            |
          </span>
        }
        <div>
          <label for="pageSizes" class="mx-2">Page Size </label>
          <select id="pageSizes" (change)="onPageSizeChange($event)">
            @for (pageSize of pageSizes; track pageSize) {
              <option [value]="pageSize" [selected]="pageSize === paging.pageSize">
                {{ pageSize }}
              </option>
            }
          </select>
        </div>
        @if (includeResetFiltersButton) {
          <div class="ms-2">
            |
            <a href="javascript:;"
              class="text-danger"
              (click)="onResetFiltersClick($event)">
              Reset Filters
            </a>
          </div>
        }
      </form>
    </div>
  </div>
}
